import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getDrainSelector } from '../selectors'
import { saveDrain } from '../store/drain.actions'
import { DrainConstants } from '../store/drain.constants'
import { IDrainState } from '../store/drain.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const drainState: IDrainState = yield select(getDrainSelector)
  const { successfulAttempt } = drainState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.drainStateList && pcrDoc.patient?.drainStateList.length) {
        const index = pcrDoc.patient?.drainStateList?.findIndex((drain) => drain.key === drainState.key)
        if (index !== -1) {
          if (pcrDoc.patient.drainStateList[index].successfulAttempt !== successfulAttempt) {
            yield put(saveDrain())
          }
        }
      } else {
        yield put(saveDrain())
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([DrainConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
